<template>
    <div class="page-tabs">
        <button
            v-for="tab in tabs"
            :key="tab.key"
            type="button"
            class="page-tab"
            :class="{ active: active === tab.key }"
            @click="$emit('change', tab.key)"
        >
            <span v-if="tab.icon" class="material-icons-outlined page-tab-icon">{{ tab.icon }}</span>
            {{ tab.label }}
            <span v-if="tab.badge" class="page-tab-badge">{{ tab.badge }}</span>
        </button>
    </div>
</template>

<script>
export default {
    name: "PageTabs",
    props: {
        tabs: { type: Array, required: true },
        active: { type: String, default: "" },
    },
};
</script>

<style lang="scss" scoped>
.page-tabs {
    display: flex;
    flex-wrap: nowrap;
    align-items: stretch;
    padding: 0 16px;
    overflow-x: auto;
}
.page-tab {
    display: flex;
    align-items: center;
    gap: 6px;
    height: 52px;
    padding: 0 10px;
    margin-right: 8px;
    border: none;
    border-bottom: 2px solid transparent;
    background: none;
    font-size: 13px;
    font-weight: 500;
    color: #595959;
    cursor: pointer;
    white-space: nowrap;

    &:hover {
        color: var(--primary-color);
    }
    &.active {
        color: var(--primary-color);
        border-bottom-color: var(--primary-color);
        font-weight: 600;
    }
}
.page-tab-icon {
    font-size: 18px !important;
}
.page-tab-badge {
    font-size: 11px;
    font-weight: 700;
    background: var(--primary-color-opacity, rgba(232, 96, 44, 0.1));
    color: var(--primary-color);
    border: 1px solid var(--primary-color);
    border-radius: 999px;
    padding: 0 7px;
    line-height: 16px;
}
</style>
